<div class="dialog">
    <div mat-dialog-content>
        <h3>Дали сте сигурни?</h3>
    </div>
    <div mat-dialog-actions class="actions">
        <button mat-raised-button (click)="onNo()" cdkFocusInitial color="primary" class="action">Не</button>
        <button mat-raised-button (click)="onYes()" cdkFocusInitial color="primary" class="action">Да</button>
    </div>
</div>
